<template>
  <div>
    <h1 class="logo">
      <component :is="unlink?'span':'a'" :to="hanatourMain">
        <span class="">
          <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 432.96 85.037" title="하나투어" aria-labelledby="hanatour-logo-svg" role="image">
            <defs>
              <style>
                .cls-1{fill:#5e2bb8}.cls-2{fill:#07d0da}
              </style>
            </defs>
            <g transform="translate(0 -.004)">
              <path class="cls-1" d="m183.87 236.91-19.94-10a3 3 0 0 1-1.67-2.71v-70.32a1.81 1.81 0 0 1 2.63-1.62l19.94 10a3 3 0 0 1 1.67 2.71v70.34a1.82 1.82 0 0 1-2.63 1.6z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="m251.76 236.91-19.94-10a3 3 0 0 1-1.68-2.71v-70.32a1.81 1.81 0 0 1 2.63-1.62l19.94 10a3 3 0 0 1 1.68 2.71v70.34a1.82 1.82 0 0 1-2.63 1.6z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-2" d="m198.83 193.27 19.94-10a3 3 0 0 0 1.67-2.71v-26.68a1.81 1.81 0 0 0-2.63-1.62l-19.94 10a3 3 0 0 0-1.67 2.71v26.7a1.82 1.82 0 0 0 2.63 1.6z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-2" d="m198.83 236.91 19.94-10a3 3 0 0 0 1.67-2.71v-26.68a1.81 1.81 0 0 0-2.63-1.62l-19.94 10a3 3 0 0 0-1.67 2.71v26.7a1.82 1.82 0 0 0 2.63 1.6z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="M456 199.17h54.9a.83.83 0 0 0 .83-.83v-8.2a.83.83 0 0 0-.83-.83h-43.53v-4.93h41.51a.83.83 0 0 0 .83-.82v-7.87a.83.83 0 0 0-.83-.83h-41.51V170H510a.83.83 0 0 0 .83-.82V161a.83.83 0 0 0-.83-.82h-54a.82.82 0 0 0-.82.82v37.33a.83.83 0 0 0 .82.84z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="M310 160.12a.83.83 0 0 0-.83-.83h-10.91a.83.83 0 0 0-.83.83v13.4h-18.89a.82.82 0 0 0-.82.82v9.55a.83.83 0 0 0 .82.83H289c-4.32 2.65-7.43 7.06-7.43 14.09 0 11.54 9.85 20.19 22.18 20.19s22.18-8.65 22.18-20.19c0-7-3.12-11.44-7.44-14.09h11.24v-11.2H310zm-6.27 48.35c-5.49 0-10.53-4.14-10.53-11a10.54 10.54 0 1 1 21.06 0c-.02 6.86-5.07 11-10.55 11z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="M594.36 158.17h-10.67a.83.83 0 0 0-.83.83v24h-10c-2.48-11-12-18.15-23.57-18.15-13.44 0-23.86 9.75-23.86 23.86s10.42 24.09 23.86 24.09c11.47 0 21-7.26 23.52-18.15h10.09v40.79a.83.83 0 0 0 1.06.8l10.67-3.11a.82.82 0 0 0 .59-.79V159a.83.83 0 0 0-.86-.83zm-45.11 43.13c-7.28 0-11.87-5.6-11.87-12.55s4.59-12.32 11.87-12.32 12.21 5.38 12.21 12.32-4.93 12.55-12.21 12.55z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="M520 204h-74.4a.83.83 0 0 0-.83.82V214a.83.83 0 0 0 .83.82h31v21.3a.82.82 0 0 0 1.06.79l10.9-3.21a.82.82 0 0 0 .59-.79v-18.06H520a.83.83 0 0 0 .83-.82v-9.22a.83.83 0 0 0-.83-.81z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="M359 183h-13.06v-24a.83.83 0 0 0-.83-.83h-10.78a.83.83 0 0 0-.83.83v77.15a.82.82 0 0 0 1.06.79l10.79-3.2a.84.84 0 0 0 .59-.8v-38.25H359a.83.83 0 0 0 .83-.83v-10a.83.83 0 0 0-.83-.86z" transform="translate(-162.26 -152.06)"/>
              <path class="cls-1" d="M441.78 183h-13.06v-24a.83.83 0 0 0-.83-.83h-10.67a.83.83 0 0 0-.82.83v40.49c-12.26 2.78-28.6 3.38-36.3 3.38h-.56v-40.29a.82.82 0 0 0-.82-.82h-10.78a.83.83 0 0 0-.83.82v51.33a.83.83 0 0 0 .83.83h6.9c15.83 0 30.41-1.06 41.56-3.19v24.6a.82.82 0 0 0 1.06.79l10.67-3.2a.83.83 0 0 0 .59-.79v-38.26h13.06a.83.83 0 0 0 .83-.83v-10a.83.83 0 0 0-.83-.86z" transform="translate(-162.26 -152.06)"/>
            </g>
          </svg>
        </span>
      </component>
    </h1>
  </div>
</template>

<script>
  import { hosts } from '~/config';

  export default {
    props: {
      size: Number,
      unlink: Boolean
    },
    computed: {
      width() {
        return `${this.size*1.9583}px`
      },
      widthBeta() {
        return `${this.size*1.9583*0.441289}px`
      },
      height() {
        return `${this.size}px`
      },
      hanatourMain() {
        return hosts.hanatour;
      },
    }
  }
</script>

<style scoped lang="scss">
  header.floating:hover h1.logo,
  header h1.logo {
    a {
      margin: 0 -10px;
      padding: 0 10px;
      white-space: nowrap
    }
  }
  .cls-1{fill:#5e2bb8}
  .cls-2{fill:#07d0da}
</style>
